(() => {
  function init(root) {
    root.querySelectorAll('[data-kv-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const variants = JSON.parse(product.querySelector('[data-kv-variants]').textContent);
      const form = product.querySelector('form');
      const select = product.querySelector('[data-kv-variant]');
      const button = product.querySelector('[data-kv-submit]');
      const message = product.querySelector('[data-kv-message]');
      const slides = [...product.querySelectorAll('.kv-store-slide')];
      let index = 0;
      function show(next) {
        if (!slides.length) return;
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause()); });
        product.querySelectorAll('[data-gallery-index]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.galleryIndex) === index)));
        const count = product.querySelector('[data-gallery-count]');
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
      }
      product.querySelectorAll('[data-gallery-index]').forEach(b => b.addEventListener('click', () => show(Number(b.dataset.galleryIndex))));
      product.querySelectorAll('[data-gallery-step]').forEach(b => b.addEventListener('click', () => show(index + Number(b.dataset.galleryStep))));
      function update() {
        const v = variants.find(v => String(v.id) === select.value);
        button.disabled = !v?.available;
        button.textContent = v?.available ? 'Add to cart' : 'Sold out';
        if (!v) return;
        product.querySelector('[data-kv-price]').textContent = v.price;
        const compare = product.querySelector('[data-kv-compare]');
        compare.textContent = v.compare; compare.hidden = !v.onSale;
        const mediaIndex = slides.findIndex(s => s.dataset.mediaId === String(v.mediaId));
        if (mediaIndex >= 0) show(mediaIndex);
      }
      select.addEventListener('change', () => {
        update(); message.textContent = '';
        if (!product.hasAttribute('data-kv-knee')) {
          const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState({}, '', url);
        }
      });
      if (product.hasAttribute('data-kv-knee')) {
        const singles = variants.filter(v => v.pack === 1);
        const initial = variants.find(v => String(v.id) === select.value) || singles[0];
        const sizes = [...new Set(singles.map(v => v.options[0]))];
        const sides = [...new Set(singles.map(v => v.options[1]))];
        let pack = initial.pack;
        const picks = Array.from({length:4}, () => [...(initial.pack === 1 ? initial.options : singles[0].options)]);
        const panel = document.createElement('div'); panel.className = 'kv-knee-options';
        select.before(panel); select.hidden = true;
        product.querySelector(`label[for="${select.id}"]`).hidden = true;
        const fields = document.createElement('div'); form.append(fields);
        const escape = text => String(text).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
        const options = (values, selected) => values.map(value => `<option${value === selected ? ' selected' : ''}>${escape(value)}</option>`).join('');
        function applyFit() {
          const variant = pack === 1 ? singles.find(v => v.options[0] === picks[0][0] && v.options[1] === picks[0][1]) : variants.find(v => v.pack === pack);
          select.value = variant ? String(variant.id) : '';
          fields.replaceChildren();
          if (pack > 1) picks.slice(0, pack).forEach((pick, i) => {
            const input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[Piece ${i+1}]`; input.value = pick.join(' / '); fields.append(input);
          });
          if (pack > 1) { const input = document.createElement('input'); input.type='hidden'; input.name='properties[Package]'; input.value=`${pack} Pieces`; fields.append(input); }
          update(); message.textContent = '';
        }
        function renderFit() {
          panel.innerHTML = `<fieldset class="kv-fit-options"><legend>Size</legend><div class="kv-size-buttons">${sizes.map(size => `<button type="button" data-fit-size="${escape(size)}" aria-pressed="${size === picks[0][0]}">${escape(size)}</button>`).join('')}</div></fieldset><fieldset class="kv-fit-options"><legend>Side</legend><div class="kv-side-buttons">${sides.map(side => `<button type="button" data-fit-side="${escape(side)}" aria-pressed="${side === picks[0][1]}">${escape(side)}</button>`).join('')}</div></fieldset><fieldset class="kv-pack-options"><legend>Select a package</legend>${[1,2,4].map(count => {
            const variant = count === 1 ? singles.find(v => v.options[0] === picks[0][0] && v.options[1] === picks[0][1]) : variants.find(v => v.pack === count);
            return `<button type="button" data-kv-pack="${count}" aria-pressed="${count === pack}"${!variant?.available ? ' disabled' : ''}><span>${count === 1 ? '1 Piece' : count+' Pieces'}</span><span>${escape(variant?.price || 'Unavailable')}${variant?.onSale ? `<s>${escape(variant.compare)}</s>` : ''}</span></button>`;
          }).join('')}</fieldset>${pack > 1 ? '<p>Choose the size and side for each piece:</p><div class="kv-piece-options">'+picks.slice(0,pack).map((pick,i) => `<div class="kv-fit-row"><label>Piece ${i+1} size<select data-piece="${i}" data-option="0" aria-label="Piece ${i+1} size">${options(sizes,pick[0])}</select></label><label>Piece ${i+1} side<select data-piece="${i}" data-option="1" aria-label="Piece ${i+1} side">${options(sides,pick[1])}</select></label></div>`).join('')+'</div>' : ''}`;
          applyFit();
        }
        panel.addEventListener('click', event => {
          const target = event.target.closest('button');
          if (!target || target.disabled) return;
          if (target.hasAttribute('data-kv-pack')) {
            pack = Number(target.dataset.kvPack); renderFit();
            panel.querySelector(`[data-kv-pack="${pack}"]`).focus();
          } else if (target.hasAttribute('data-fit-size') || target.hasAttribute('data-fit-side')) {
            const size = target.hasAttribute('data-fit-size');
            const attribute = size ? 'data-fit-size' : 'data-fit-side';
            const value = target.getAttribute(attribute);
            picks.forEach(pick => { pick[size ? 0 : 1] = value; }); renderFit();
            [...panel.querySelectorAll(`[${attribute}]`)].find(b => b.getAttribute(attribute) === value)?.focus();
          }
        });
        panel.addEventListener('change', event => {
          const target = event.target;
          if (target.matches('[data-fit-size]')) { picks.forEach(pick => { pick[0]=target.value; }); renderFit(); panel.querySelector('[data-fit-size]').focus(); }
          else if (target.matches('[data-fit-side]')) { picks.forEach(pick => { pick[1]=target.value; }); renderFit(); panel.querySelector('[data-fit-side]').focus(); }
          else if (target.matches('[data-piece]')) { picks[Number(target.dataset.piece)][Number(target.dataset.option)] = target.value; applyFit(); }
        });
        renderFit();
      }
      update();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity() || button.disabled) return;
        button.disabled = true; message.textContent = 'Adding…';
        try {
          const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), {method: 'POST', body: new FormData(form), headers: {'Accept': 'application/json'}});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
          message.textContent = 'Added to your cart';
          document.querySelector('#cart-icon-bubble')?.click();
        } catch (error) { message.textContent = error.message; }
        finally { update(); }
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
